import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../component_dependent/config';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class CustomQueryService extends Config {

  constructor(private httpClient: HttpClient,
    private storageService: StorageService) {
    super();
  }

  public getContactsAndRecentMessage(arr: []) {
    var url;

    url = this.BASE_URL + "contact_message_recent_get";

    return this.httpClient.post(url, {'conversation_id' : arr}, this.storageService.getHeaders());
  }
}
